import { render, staticRenderFns } from "./HomeBannerEventCard.vue?vue&type=template&id=55345284"
import script from "./HomeBannerEventCard.vue?vue&type=script&lang=js"
export * from "./HomeBannerEventCard.vue?vue&type=script&lang=js"
import style0 from "./HomeBannerEventCard.vue?vue&type=style&index=0&id=55345284&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports